import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  insuranceProviderAction,
  relationAction,
  updateInsuranceAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import DatePicker from "react-datepicker";
import ItemsInputField from "../forms/items-input-field";
import TickIcon from "../../assets/icons/tick-icon";
import SelectField from "../forms/select-field";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { handelEnabled } from "./handel-enabled";
import { handelLabel } from "./handel-label";
import Insurance2Icon from "../../assets/icons/admin-customer-icons/insurance2-icon";
import HealthInsuranceIcon from "../../assets/icons/admin-customer-icons/health-insurance-icon";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Insurance({
  customerId,
  insurance,
  page,
  disabled,
  // loading,
  // setLoading,
  insuranceId,
  customization,
}) {
  const [insuranceProvider, setInsuranceProvider] = useState(null);
  const [customData, setcustomData] = useState([]);
  const [loading, setLoading] = useState(false);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let initialValues = {
    insurance: (localStorageData?.insurance ?? insurance).map(
      (item, index) => ({
        ...item,
        cmr_policy_period_from: moment(item.cmr_policy_period_from).format(
          "YYYY-MM-DD"
        ),
        cmr_policy_period_to: moment(item.cmr_policy_period_to).format(
          "YYYY-MM-DD"
        ),
      })
    ),
  };

  const addInsurance = {
    // Unique family member ID (ulid or uuid)
    cmr_id: customerId,
    // cmr_policy_id: insuranceId ?? initialValues.insurance[0].cmr_policy_id,
    cmr_policy_holder_name: "",
    cmr_policy_number: "",
    cmr_insurance_provider: "",
    cmr_policy_period_from: "",
    cmr_policy_period_to: "",
    cmr_premium_amount: 0,
    cmr_contact_person: "",
    cmr_coverage_details: "",
    cmr_claim_history: "",
  };

  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  //   useEffect(() => {}, []);
  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
      id: item.id
    }));
  }
  const onSuccess = (data) => {
    setLoading(false);
    successToast(data.message);
    navigate('/admin/customer');
  };
  const onInsuranceSuccess = (data) => {
    const res = convertArray(data.data);
    setInsuranceProvider(res);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data.message);
  };

  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(insuranceProviderAction(onInsuranceSuccess, onError));
    }
  }, []);
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          insurance: values.insurance,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };

  const handleAddInsurance = (values, setFieldValue) => {
    const updatedInsurance = [...values.insurance, { ...addInsurance }];
    setFieldValue("insurance", updatedInsurance);
  };

  const handleDeleteInsurance = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one insurance");
    else if (values.insurance[index].cmr_is_default === true) {
      return errorToast("Cannot delete the default insurance");
    } else {
      const updatedBank = values.insurance.filter((_, i) => i !== index);
      setFieldValue("insurance", updatedBank);
    }
  };
  function cleanInvalidDatesFromFamily(family) {
    family.forEach((member) => {
      if (
        member.cmr_policy_period_from === "Invalid date" ||
        member.cmr_policy_period_from === ""
      ) {
        delete member.cmr_policy_period_from;
      }
      if (
        member.cmr_policy_period_to === "Invalid date" ||
        member.cmr_policy_period_to === ""
      ) {
        delete member.cmr_policy_period_to;
      }
    });
  }
  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;
    setLoading(true);
    values.insurance.forEach((item, index) => {
      const name = item.cmr_insurance_provider;
      if (name) {
      const match = insuranceProvider.find(item => item.label === name);
      if (match) {
        values.insurance[index].cmr_insurance_provider_id = match.id;
      }
    }
    })
    let cleanData = [...values.insurance];
    cleanInvalidDatesFromFamily(cleanData);
    // let sendData = [...values.insurance];
    // if (page !== "edit") {
    //   let firstItem = values.insurance[0];
    //   let updatedFirstItem = {
    //     ...firstItem,
    //     cmr_id: customerId,
    //     cmr_policy_id: insuranceId,
    //   };
    //   sendData[0] = updatedFirstItem;
    // }
    dispatch(
      updateInsuranceAction({ insuranceData: cleanData }, onSuccess, onError)
    );
    console.log(cleanData);
  };

  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "insurance");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          {/* <UpdateCmrId customerId={customerId} /> */}
          {/* <UpdateInsuranceId insuranceId={insuranceId} /> */}
          <UpdateLocalStorage values={values} />
          {/* <LoadingOverlay isLoading={loading} /> */}

          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Insurance2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Insurance policies
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Manage all insurance coverage details
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddInsurance(values, setFieldValue)}
                  text={<span>Add New Policies</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            </div>
            {console.log("==", values.insurance)}
            {values?.insurance?.map((item, index) => (
              <div
                // key={index}
                className=" px-[34px] pt-[34px] pb-[10px]  flex-col  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
              >
                <div className="flex  mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    {/* <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl"> */}
                    <HealthInsuranceIcon />
                    {/* </div> */}
                    <div className="flex flex-col justify-between">
                      <label className="h-full text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        Health Insurance
                      </label>
                      <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                        Policy #{item.cmr_policy_number || index + 1}
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    <button
                      type="button"
                      // disabled={values.pay.length <= 1}
                      onClick={() => {
                        if (page !== "view") {
                          handleDeleteInsurance(
                            index,
                            values,
                            setFieldValue,
                            values.insurance.length
                          );
                        }
                      }}
                      className={`${
                        values.insurance.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
                <div
                  className="grid gap-x-3 gap-y-0  min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_policy_holder_name",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`insurance[${index}].cmr_policy_holder_name`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_policy_holder_name",
                          customData
                        )}`}
                        label={handelLabel(
                          "cmr_policy_holder_name",
                          customData
                        )}
                        isDisabled={handelEnabled(
                          "cmr_policy_holder_name",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]  `}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {(shouldBeDisplay(
                    "cmr_policy_period_from",
                    page,
                    customData
                  ) ||
                    shouldBeDisplay(
                      "cmr_policy_period_to",
                      page,
                      customData
                    )) && (
                    <div className="col-span-1">
                      <label
                        className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      >
                        Policy Period
                      </label>

                      <div className="flex flex-row gap-4">
                        {shouldBeDisplay(
                          "cmr_policy_period_from",
                          page,
                          customData
                        ) && (
                          <InputField
                            type="date"
                            // isRequired={true}
                            labelClass={`w-min text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            parentClass="w-min flex flex-row items-center gap-4 w-full" // gap-2 = 8px
                            name={`insurance[${index}].cmr_policy_period_from`}
                            placeholder={`Select ${handelLabel(
                              "cmr_policy_period_from",
                              customData
                            )}`}
                            label={handelLabel(
                              "cmr_policy_period_from",
                              customData
                            )}
                            isDisabled={handelEnabled(
                              "cmr_policy_period_from",
                              page,
                              customData
                            )}
                            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]  `}
                            containerClass="w-full h-min"
                            labelWidth="auto"
                          />
                        )}

                        {shouldBeDisplay(
                          "cmr_policy_period_to",
                          page,
                          customData
                        ) && (
                          <InputField
                            type="date"
                            // isRequired={true}
                            labelClass={`w-min text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            parentClass="w-min flex flex-row items-center gap-4 w-full" // gap-2 = 8px
                            name={`insurance[${index}].cmr_policy_period_to`}
                            placeholder={`Select ${handelLabel(
                              "cmr_policy_period_to",
                              customData
                            )}`}
                            label={handelLabel(
                              "cmr_policy_period_to",
                              customData
                            )}
                            isDisabled={handelEnabled(
                              "cmr_policy_period_to",
                              page,
                              customData
                            )}
                            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]  `}
                            containerClass="w-full h-min"
                            labelWidth="auto"
                            min={moment(
                              values.insurance[index].cmr_policy_period_from
                            ).format("YYYY-MM-DD")}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {shouldBeDisplay(
                    "cmr_insurance_provider",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={insuranceProvider?.find(
                          (option) =>
                            option?.value === item?.cmr_insurance_provider
                        )}
                        label={handelLabel(
                          "cmr_insurance_provider",
                          customData
                        )}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_insurance_provider",
                          page,
                          customData
                        )}
                        // errMsgContainerClass="hidden"
                        id={`insurance[${index}].cmr_insurance_provider`}
                        placeholder={`Select ${handelLabel(
                          "cmr_insurance_provider",
                          customData
                        )}`}
                        options={insuranceProvider}
                        name={`insurance[${index}].cmr_insurance_provider`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}

                  {shouldBeDisplay("cmr_premium_amount", page, customData) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`insurance[${index}].cmr_premium_amount`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_premium_amount",
                          customData
                        )}`}
                        label={handelLabel("cmr_premium_amount", customData)}
                        isDisabled={handelEnabled(
                          "cmr_premium_amount",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay("cmr_policy_number", page, customData) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`insurance[${index}].cmr_policy_number`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_policy_number",
                          customData
                        )}`}
                        label={handelLabel("cmr_policy_number", customData)}
                        isDisabled={handelEnabled(
                          "cmr_policy_number",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay("cmr_contact_person", page, customData) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`insurance[${index}].cmr_contact_person`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_contact_person",
                          customData
                        )}`}
                        label={handelLabel("cmr_contact_person", customData)}
                        isDisabled={handelEnabled(
                          "cmr_contact_person",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>

                {(shouldBeDisplay("cmr_coverage_details", page, customData) ||
                  shouldBeDisplay("cmr_claim_history", page, customData)) && (
                  <div className="flex  gap-3 w-full">
                    {shouldBeDisplay(
                      "cmr_coverage_details",
                      page,
                      customData
                    ) && (
                      <div className="flex flex-col gap-2 w-full">
                        <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                          {handelLabel("cmr_coverage_details", customData)}
                        </label>
                        <TextAreaField
                          name={`insurance[${index}].cmr_coverage_details`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_coverage_details",
                            customData
                          )}`}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass=" flex  flex-col gap-2 w-full align-end "
                          label=""
                          isDisabled={handelEnabled(
                            "cmr_coverage_details",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
                    `}
                          containerClass="flex flex-col gap-2 w-full "
                        />
                      </div>
                    )}
                    {shouldBeDisplay("cmr_claim_history", page, customData) && (
                      <div className="flex flex-col gap-2 w-full">
                        <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                          {handelLabel("cmr_claim_history", customData)}
                        </label>
                        <TextAreaField
                          name={`insurance[${index}].cmr_claim_history`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_claim_history",
                            customData
                          )}`}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          label=""
                          isDisabled={handelEnabled(
                            "cmr_claim_history",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
                    `}
                          containerClass="flex flex-col gap-2 w-full "
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${customerId}`, {
                      state: { tab: "Insurance" },
                    })
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Insurance;

function UpdateCmrId({ customerId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.insurance?.[0] &&
      !Object.hasOwn(values.insurance[0], "cmr_id")
    ) {
      setFieldValue("insurance[0].cmr_id", customerId);
    }
  }, [customerId, setFieldValue]);

  return null;
}

function UpdateInsuranceId({ insuranceId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.insurance?.[0] &&
      !Object.hasOwn(values.insurance[0], "cmr_policy_id")
    ) {
      setFieldValue("insurance[0].cmr_policy_id", insuranceId);
    }
  }, [insuranceId, setFieldValue]);

  return null;
}
